var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOperator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    style: {
      enableBackground: "new 0 0 100 125"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.8,39.7c-1.7-6.2-4.8-12.2-8.9-17.3C69.6,13.3,60,10,50,10s-19.6,3.3-26.9,12.4c-4.1,5.1-7.2,11.1-8.9,17.3 c-2.4,0.5-4.2,2.6-4.2,5.1v15.7c0,2.9,2.3,5.2,5.2,5.2s5.2-2.3,5.2-5.2v-1.8C23.7,73.8,35.7,90,50,90c12.8,0,23.8-13,28.3-26.7 c0.5-1.4,0.9-2.8,1.3-4.3v1.4c0,2.9,2.3,5.2,5.2,5.2s5.2-2.3,5.2-5.2V44.8C90,42.2,88.2,40.1,85.8,39.7z M75.8,62.5 c-3.2,8.1-10.9,14-19.9,14.7c-0.5-1.3-1.8-2.3-3.3-2.3h-5.2c-1.9,0-3.5,1.5-3.5,3.5s1.6,3.5,3.5,3.5h5.2c1.4,0,2.6-0.8,3.2-2 c5.3-0.4,10.2-2.3,14.1-5.3c-0.2,0.2-0.3,0.5-0.5,0.7c-2.7,3.7-5.8,6.8-9,8.8c-3.4,2.2-6.9,3.3-10.4,3.3s-7-1.1-10.4-3.3 c-3.2-2.1-6.3-5.1-9-8.8c-5.2-7.2-8.4-16.6-8.4-24.3c0-0.2,0-0.4,0-0.5c4.7-2.4,9.1-6.4,12.5-11.8c0.1-0.2,0.2-0.4,0.3-0.5 c0.8-1.3,2.5-1.5,3.6-0.5c3.5,3.3,8,6.3,13.2,8.6h0.1c4.3,1.9,9.3,1.5,13.4-0.8c1.2-0.7,2.7-1.1,4.2-1.1c3.4,0,8,4.6,8.1,4.6 c0,0.7,0.1,1.3,0.1,2C77.8,54.5,77.1,58.5,75.8,62.5z M79.7,43.8C76.6,29.6,64.5,17,50,17S23.5,29.6,20.4,43.8 c-0.3-1.6-1.3-2.9-2.7-3.6c1.6-5.6,4.4-11,8.1-15.6c6.7-8.3,15.3-11.1,24.2-11.1s17.5,2.8,24.2,11.1c3.7,4.6,6.5,10,8.1,15.6 C81,40.9,80,42.2,79.7,43.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperator);
export default __webpack_public_path__ + "static/media/operator.5f2180f4.svg";
export { ForwardRef as ReactComponent };